import { render, staticRenderFns } from "./nmealplanner.vue?vue&type=template&id=f4389cb0&scoped=true&"
import script from "./nmealplanner.vue?vue&type=script&lang=js&"
export * from "./nmealplanner.vue?vue&type=script&lang=js&"
import style0 from "./nmealplanner.vue?vue&type=style&index=0&id=f4389cb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4389cb0",
  null
  
)

export default component.exports